// src/utils/apiHelpers.ts
// Shared utility functions for API calls

/**
 * Get JWT token from localStorage
 */
export function getAuthToken(): string | null {
  return localStorage.getItem('authToken');
}

/**
 * Create headers with Authorization Bearer token if available
 * @param additionalHeaders Additional headers to include
 * @returns Headers object with Content-Type and Authorization (if token exists)
 */
export function createAuthHeaders(additionalHeaders: Record<string, string> = {}): Record<string, string> {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    ...additionalHeaders,
  };
  
  const token = getAuthToken();
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  
  return headers;
}
